// Essential Free Shipping (EFS) カート画面 表示制御
(function () {
  // 二重起動防止（セクション再描画などで複数回読み込まれるケースへの対策）
  if (window.__shopEfsCartInitialized) return;
  window.__shopEfsCartInitialized = true;

  function init() {
    if (!location.pathname.startsWith("/cart")) return;

    const pickupType = localStorage.getItem("pickupType");
    if (pickupType === "in-store-pickup") {
      // 店頭の場合、class追加
      document.body.classList.add("is-in-store-pickup");
    }
  }

  init();
})();
